import { withRouter } from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  selectBank,
  changeCashTransferAttr,
  openModalSafetypay,
  selectBankCashTransfer,
  validatorHandlerBlur,
  getInfosInsureds,
} from '../../../actions/purchaseActions';
import { maskCashTransferAccount, maskCashTransferAgency } from '../../../utils';
import ErrorMessage from '../error_message/ErrorMessage';
import ButtonStage from '../../standard/button_stage/ButtonStage';

class HolderInfo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const selected_bank = this.props.banks.filter((bank) => bank.selected)[0];
    const hasFormError =
      this.props.errors && Object.values(this.props.errors.safetypay).some((value) => value !== false);

    const transferErrors = this.props.errors.safetypay;

    return (
      <div style={{ display: this.props.stepDisplayCashTransfer !== 2 && this.props.mobile ? 'none' : 'block' }}>
        <h4 className="title-cash-transfer">Dados da transferência</h4>
        {selected_bank && (
          <div className="infos-cash-transfer">
            <img src={`/assets/images/banks/${selected_bank.slug}.svg`} alt="" />
            <strong className="bank-name">{selected_bank.name}</strong> <br />
          </div>
        )}
        <form className={`transfer-form${hasFormError ? " with-error": ""}`}>
          <div className="flex">
            <div className="input-form1">
              <input
                type="text"
                name="name"
                value={this.props.name}
                placeholder={'Nome do titular'}
                onChange={this.props.handleChange}
                className={transferErrors.name ? 'with-error' : ''}
                onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'transf_name')}
              />
              <ErrorMessage anchor={`safetypay_name`} field1="safetypay" field2="name" className="form-error" />
            </div>
            <div className="input-form1">
              <MaskedInput
                name="cpf"
                guide={true}
                type="tel"
                value={this.props.cpf}
                placeholder={'CPF'}
                onChange={this.props.handleChange}
                className={transferErrors.cpf ? 'with-error' : ''}
                mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'transf_cpf')}
              />
              <ErrorMessage anchor={`safetypay_cpf`} field1="safetypay" field2="cpf" className="form-error" />
            </div>
          </div>
          <div className="flex">
            <div className="input-form1">
              <MaskedInput
                type="tel"
                name="agency"
                pattern="\d*"
                placeholder={'Agência'}
                inputMode="numeric"
                value={this.props.agency}
                guide={false}
                className={transferErrors.agency ? 'with-error' : ''}
                mask={maskCashTransferAgency(selected_bank ? selected_bank : '')}
                onChange={this.props.handleChange}
                onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'transf_agency')}
              />
              <ErrorMessage anchor={`safetypay_agency`} field1="safetypay" field2="agency" className="form-error" />
            </div>
            <div className="input-form1">
              <MaskedInput
                type="tel"
                name="account"
                pattern="\d*"
                placeholder={'Conta'}
                inputMode="numeric"
                value={this.props.account}
                guide={false}
                className={transferErrors.account ? 'with-error' : ''}
                mask={maskCashTransferAccount(selected_bank ? selected_bank : '')}
                onChange={this.props.handleChange}
                onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'transf_account')}
              />
              <ErrorMessage anchor={`safetypay_account`} field1="safetypay" field2="account" className="form-error" />
            </div>
          </div>
        </form>
        <button className="transfer-infos payment" onClick={(_) => this.props.getInfosInsureds(3)}>
          Copiar dados do primeiro segurado
        </button>
      </div>
    );
  }
}

class CardBank extends Component {
  constructor(props) {
    super(props);
    this.selectBank = this.selectBank.bind(this);
  }

  selectBank = (i) => {
    this.props.selectBankCashTransfer(2);
    this.props.selectBank(i);
  };

  render() {
    return (
      <div
        className={`area-bandeiras ${this.props.errors.safetypay.banks ? 'is-invalid' : ''}`}
        style={{ display: this.props.stepDisplayCashTransfer !== 1 && this.props.mobile ? 'none' : 'flex' }}
      >
        <h4 className="mobile">Selecione o seu banco</h4>
        <ul className="lista-bancos radio-input">
          {this.props.banks.map((bank, index) => (
            <li className="" key={index}>
              <input
                type="radio"
                id={bank.slug}
                name="name"
                checked={bank.selected}
                onClick={() => this.selectBank(index)}
                onChange={() => this.selectBank(index)}
              />
              <div>
                <label htmlFor={bank.slug}>
                  <img src={`/assets/images/banks/${bank.slug}.svg`} alt="" />
                  {this.props.mobile && bank.name}
                </label>
              </div>
            </li>
          ))}
        </ul>

        <u onClick={this.props.openModalSafetypay} className="text-safetypay mobile">
          Clique aqui para ver as condições via SafetyPay
        </u>

        <p className="bank-error-message">{this.props.errors.safetypay.banks || null}</p>
      </div>
    );
  }
}

class CashTransfer extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount(props) {
    const today = new Date();
    const deadline = today.addDays(1);
    const year = deadline.getUTCFullYear();
    const month = (deadline.getUTCMonth() + 1).toLocaleString('pt-BR', { minimumIntegerDigits: 2 });
    const day = deadline.getUTCDate().toLocaleString('pt-BR', { minimumIntegerDigits: 2 });
    this.deadline = `${day}/${month}/${year}`;
  }

  handleChange(e) {
    const field = {
      name: e.target.name,
      value: e.target.value,
    };

    this.props.changeCashTransferAttr(field);
  }

  render() {
    if (!this.props.paymentMethods.find((element) => element.slug === 'safetypay').available) return <div />;

    return (
      <div className="area-transferencia">
        <div className="area-bancos flex">
          <CardBank
            banks={this.props.banks}
            errors={this.props.errors}
            selectBank={this.props.selectBank}
            stepDisplayCashTransfer={this.props.stepDisplayCashTransfer}
            selectBankCashTransfer={this.props.selectBankCashTransfer}
            mobile={this.props.mobile}
            openModalSafetypay={this.props.openModalSafetypay}
          />
        </div>
        <HolderInfo
          name={this.props.name}
          cpf={this.props.cpf}
          handleChange={this.handleChange}
          banks={this.props.banks}
          mobile={this.props.mobile}
          stepDisplayCashTransfer={this.props.stepDisplayCashTransfer}
          validatorHandlerBlur={this.props.validatorHandlerBlur}
          getInfosInsureds={this.props.getInfosInsureds}
          errors={this.props.errors}
        />

        {this.props.mobile && this.props.stepDisplayCashTransfer === 2 ? (
          <ButtonStage data-cy="step-payment-data" index={3} stage="INSURED_PAYMENT_PURCHASE" />
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      cpf: state.purchase.safetypay.cpf,
      name: state.purchase.safetypay.name,
      banks: state.purchase.safetypay.banks,
      paymentMethods: state.purchase.paymentMethods,
      errors: state.purchase.errors,
      mobile: state.mobile.mobileActive,
      stepDisplayCashTransfer: state.purchase.stepDisplayCashTransfer,
    }),
    {
      selectBank,
      openModalSafetypay,
      changeCashTransferAttr,
      selectBankCashTransfer,
      validatorHandlerBlur,
      getInfosInsureds,
    }
  )(CashTransfer)
);



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/CashTransfer.jsx